// extracted by mini-css-extract-plugin
export default {"card":"_6-z"};